import { documents } from "@/utils/service/documents";


export default (to, from, next) => {
    const doctype = to.params.doc;

    if (!documents(to.params.locale).find(({ type }) => type === doctype)) {
        next({
            name: "home",
        });
    }

    next();
};
